import HeaderImage from "../../assets/images/main_header.jpg";
import "./PersonalDataPage.css";
import {Breadcrumb} from "antd";
import {Link} from "react-router-dom";

const PersonalDataPage = () => {


    return(
        <div className={"pdp"}>
            <div className={"pdp-image"}>
                <img src={HeaderImage} alt="Header Background" style={{width: "100%"}}/>
            </div>

            <div className={"pdp-header"}>
                <h1>Пользовательское соглашение</h1>
                <Breadcrumb className="pdp-header-breadcrumb"
                            items={[
                                {
                                    title: <Link to="/">Главная страница</Link>
                                },
                                {
                                    title: <span>Пользовательское соглашение</span>,
                                },
                            ]}
                />
                <div className="under-breadcrumb-divider"></div>
            </div>

            <div className={"pdp-content"}>
                <div className={"pdp-content-text"}>
                    <p>
                        1. Общие положения <br/>
                        1.1. Настоящее Соглашение устанавливает порядок доступа к размещенным в сети Интернет
                        информационным
                        материалам, образующим информационный ресурс https://mel.org.ru и сателлиты (далее - Сайт),
                        определяет права и обязанности лиц, осуществляющих доступ к Сайту посредством сети Интернет
                        (далее - Пользователей). <br/>

                        1.2. Владельцем Сайта, реализующим в полном объеме права по администрированию Сайта, является
                        ООО "АгроТрейд". <br/>

                        1.3. Все взаимоотношения между Владельцем Сайта и Пользователями Сайта регулируются действующим
                        законодательством Российской Федерации и настоящим Соглашением. <br/>

                        1.4. Владелец Сайта вправе в любое время изменять настоящее Соглашение. Действующая редакция
                        Соглашения находится в сети Интернет по адресу https://mel.org.ru/privacy/ <br/>
                    </p>

                    <p>
                        2. Права Владельца Сайта <br/>
                        2.1. Владелец Сайта обладает всеми исключительными правами на использование Сайта, по
                        собственному
                        усмотрению в любое время изменяет содержание Сайта, удаляет и добавляет любые материалы,
                        разрешает доступ к Сайту либо ограничивает такой доступ, осуществляет иные принадлежащие
                        ему права в отношении Сайта. <br/>

                        2.2. Владелец Сайта осуществляет администрирование Сайта с целью размещения на Сайте информации
                        о компании, ее деятельности, а также иной информации, которая, по мнению Владельца Сайта, может
                        оказаться полезной Пользователям Сайта. <br/>
                    </p>

                    <p>
                        3. Пользователи Сайта <br/>
                        3.1. Пользователем Сайта признается любое лицо, осуществляющее доступ к Сайту посредством сети
                        Интернет. <br/>

                        3.2. Права и обязанности Пользователя Сайта возникают у лица с момента первого обращения к
                        любому из материалов Сайта. <br/>

                        3.3. Пользователям Сайта предоставляется свободный доступ к информационным материалам,
                        размещенным на Сайте, за исключением материалов, доступ к которым должен быть ограничен в
                        соответствии с законодательством Российской Федерации. Пользователи Сайта обязаны воздерживаться
                        от любых действий, способных причинить вред информационному наполнению, программному и
                        аппаратному обеспечению Сайта. <br/>
                    </p>

                    <p>
                        4. Правовой статус информации, размещенной на Сайте <br/>
                        4.1. Авторские права на информационные материалы (в том числе, но, не ограничиваясь
                        перечисленным: изображения, фотографии, тексты, логотипы, дизайн отдельных блоков Сайта и всего
                        Сайта в целом), размещенные на Сайте, принадлежат Владельцу Сайта и иным правообладателям, с
                        согласия которых материалы размещены на Сайте. Иные лица не вправе каким-либо образом
                        использовать размещенные на Сайте материалы, копировать полностью или частично, распространять,
                        видоизменять, воспроизводить указанные материалы без предварительного разрешения Владельца Сайта
                        и (или) иных правообладателей. Все права на информационные материалы, в том числе на изображения
                        (фотографии), размещенные на Сайте, охраняются в соответствии с национальным и международным
                        законодательством (Глава 70 Гражданского кодекса РФ, Всемирная конвенция об авторском праве,
                        Бернская конвенция об охране литературных и художественных произведений и иные нормативные акты
                        в области охраны авторских прав). При использовании любых информационных материалов и
                        изображений (фотографий) с Сайта в сети Интернет обязательным условием является указание на
                        источник материалов - Сайт, а также активная гиперссылка на Сайт в виде:
                        https://mel.org.ru <br/>

                        4.2. Пользователи Сайта вправе свободно знакомиться с информационными материалами,
                        расположенными на Сайте в открытом доступе. Доступ к материалам, расположенным на Сайте,
                        предоставляется на безвозмездной основе. <br/>

                        4.3. Владельцем Сайта принимаются административные, организационные и технические меры по защите
                        детей от информации, причиняющей вред их здоровью и развитию. <br/>
                    </p>

                    <p>
                        5. Ответственность Сторон <br/>
                        5.1. Владелец Сайта не несет ответственности за убытки, возникшие у Пользователей Сайта по
                        причинам, связанным с техническими сбоями аппаратного и программного обеспечения, а также за
                        убытки, возникшие в результате действий Пользователей Сайта. Владелец Сайта не несет финансовой
                        и правовой ответственности за убытки, возникшие у Пользователей Сайта или третьих лиц в
                        результате использования Пользователями Сайта размещенных на Сайте любых информационных
                        материалов и рекомендаций. Используя материал сайта, вы соглашаетесь с тем, что все финансовые и
                        правовые риски несёте сами. <br/>

                        5.2. Нарушение Пользователем Сайта условий настоящего Соглашения может явиться основанием для
                        временного либо полного отказа в доступе Пользователя к Сайту, которое принимается Владельцем
                        Сайта. Нарушение Пользователем Сайта авторских прав Владельца Сайта является основанием для
                        привлечения Пользователя Сайта к ответственности, предусмотренной законом (статьи 1252, 1301
                        Гражданского кодекса РФ, статья 146 Уголовного кодекса РФ, статья 7.12 Кодекса РФ об
                        административных правонарушениях, иные нормы законодательства РФ). <br/>
                    </p>

                    <p>
                        6. Конфиденциальность и защита информации <br/>
                        6.1. Персональные данные Пользователя Сайта обрабатывается в соответствии с ФЗ «О персональных
                        данных» № 152-ФЗ. Владелец сайта обрабатывает персональные данные Пользователя сайта в рамках
                        Договоров поставки товара. <br/>

                        6.2. При добавлении сообщения на Сайт Пользователь Сайта предоставляет следующую информацию:
                        Название организации, электронная почта организации, телефон организации. Осуществляя добавление
                        информации на сайте, Пользователь подтверждает, что принимает условия настоящего Соглашения и
                        условия обработки персональных данных, указанных в нем. <br/>

                        6.3. Предоставляя свои персональные данные Владельцу Сайта (путем отправки заявки на Сайте или
                        иным
                        законным способом), Пользователь Сайта соглашается на их обработку Владельцем Сайта.
                        Пользователь соглашается на обработку своих персональных данных Владельцем сайта в целях
                        осуществления Владельцем Сайта клиентской поддержки в рамках исполнения Договорных
                        отношений. <br/>

                        6.4. Под обработкой персональных данных понимается любое действие (операция) или совокупность
                        действий (операций), совершаемых с использованием средств автоматизации или без использования
                        таких средств с персональными данными, включая сбор, запись, систематизацию, накопление,
                        хранение, уточнение (обновление, изменение) извлечение, использование, передачу (в том числе
                        передачу третьим лицам, не исключая трансграничную передачу, если необходимость в ней возникла в
                        ходе исполнения обязательств ), обезличивание, блокирование, удаление, уничтожение персональных
                        данных. <br/>

                        6.4.1. Предоставляя свои персональные данные Владельцу Сайта (путем регистрации на Сайте или
                        иным законным способом), Пользователь Сайта соглашается с тем, что Владелец Сайта имеет право
                        отправлять информационные, в том числе рекламные сообщения, на электронную почту и мобильный
                        телефон Пользователя/Покупателя с его согласия, выраженного посредством совершения им действий,
                        однозначно идентифицирующих этого абонента и позволяющих достоверно установить его
                        волеизъявление на получение сообщения. Пользователь/Покупатель вправе отказаться от получения
                        рекламной и другой информации без объяснения причин отказа путем информирования Владельца Сайта
                        о своем отказе посредством направления соответствующего заявления на электронный адрес Владельца
                        Сайта. <br/>

                        6.4.2. Предоставляя свои персональные данные Владельцу Сайта (путем регистрации на Сайте или
                        иным законным способом), Пользователь Сайта соглашается с тем, что Владелец сайта вправе
                        осуществлять электронные рассылки новостей, информации о специальных предложениях и акциях
                        владельца сайта, отправлять индивидуальные ответы на обращения своих клиентов по вопросам
                        исполнения заказов, пользования сервисом, пожеланий и предложений в адрес владельца сайта. <br/>


                        6.4.3. Пользователь имеет право отозвать своё согласие на обработку персональных данных
                        посредством направления соответствующего письменного заявления в адрес Владельца Сайта по почте
                        заказным письмом с уведомлением о вручении. В таком случае вся полученная от Пользователя
                        информация (в том числе его учётная запись) удаляется из клиентской базы Владельца Сайта. <br/>

                        Полный перечень прав Пользователя как субъекта персональных данных определён в Главе 3
                        Федерального закона №152-ФЗ «О защите персональных данных». <br/>

                        6.5. Владелец Сайта вправе использовать технологию «cookies», «Cookies» не содержат
                        конфиденциальную информацию. Посетитель / Пользователь дает согласие на сбор, анализ и
                        использование cookies, в том числе третьими лицами для целей формирования статистики и
                        оптимизации рекламных сообщений. <br/>

                        6.6. Владелец Сайта получает информацию об IP-адресе посетителя Сайта https://mel-org.ru/.
                        Данная информация не используется для установления личности посетителя. <br/>

                        6.7. С целью повышения качества обслуживания Владелец Сайта вправе осуществлять записи
                        телефонных разговоров с Пользователем. При этом Владелец Сайта обязуется: предотвращать попытки
                        несанкционированного доступа к информации, полученной в ходе телефонных переговоров, в
                        соответствии с п. 4 ст. 16 Федерального закона «Об информации, информационных технологиях и о
                        защите информации». <br/>

                        6.8. Принятие Соглашения является обязательным условием для отправки заявки: Пользователь не
                        может
                        отправить предварительную заявку через онлайн-витрину до ознакомления с настоящим Соглашением и
                        предоставления согласия с настоящим Соглашением <br/>

                        6.9.Владелец Сайта оставляет за собой право вносить изменения в настоящее Соглашение. <br/>
                    </p>
                </div>
            </div>

        </div>
    )
}

export default PersonalDataPage;